export function FeedbackText({icon = 'icon-warning', className = '', role = '', children}) {
  return <div className={`feedback-text feedback-text--info ${className}`}>
    <div className="feedback-text__icon-container"><span className={`feedback-text__icon ${icon}`}></span></div>
    <div className="feedback-text__content" role={role}>{children}</div>
  </div>
}

export function ErrorText({icon = 'icon-warning', className = '',children, ...attributes}) {
  return <div className={`feedback-text feedback-text--error ${className}`} {...attributes}>
    <div className="feedback-text__icon-container"><span className={`feedback-text__icon ${icon}`}></span></div>
    <div className="feedback-text__content" role="alert">{children}</div>
  </div>
}